import { useState } from 'react';
	function UserProfileCard({ user }) {
        const [editMode, setEditMode] = useState(false);
        const [formData, setFormData] = useState({ name: user.name, email: user.email });
    
        const handleEdit = () => setEditMode(true);
        const handleSave = () => {
            // Save the data to some API or state
            console.log('Data saved', formData);
            setEditMode(false);
        };
        const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
    
        return (
            <div>
                {editMode ? (
                    <>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} />
                        <input type="email" name="email" value={formData.email} onChange={handleChange} />
                        <button onClick={handleSave}>Save</button>
                    </>
                ) : (
                    <>
                        <h2>{user.name}</h2>
                        <p>{user.email}</p>
                        <button onClick={handleEdit}>Edit</button>
                    </>
                )}
            </div>
        );
    }
export default UserProfileCard